import {Button, Modal, Typography} from "antd";
import React from "react";

const {Title, Text} = Typography;


const StartModal = ({modalVisible, setModalVisible}) => {
    return (
        <Modal
            open={modalVisible}
            closable={false}
            width={600}
            footer={null}
            centered
            styles={{
                mask: {
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }
            }}
        >
            <div style={{textAlign: 'center'}}>
                <Title level={4}>Testni boshlaysizmi?</Title>
                <Text>
                    Testni boshlagandan soʻng 2 soat vaqt beriladi.
                    Vaqt orqaga sanab boshlagach, chiqib ketsangiz ham vaqt toʻxtamaydi.
                    Faqatgina <b>Toʻxtatish</b> tugmasi orqali testni yakunlash mumkin.
                </Text>
                <br></br>
                <Button
                    type="primary"
                    size="large"
                    style={{marginTop: 24, width: 200}}
                    onClick={() => setModalVisible(false)}
                >
                    Ha
                </Button>
            </div>
        </Modal>
    )
}

export default StartModal;